module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$lang.labels.licenseActivationText))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.no))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.activating
    },
    on: {
      "click": function($event) {
        return _vm.activate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.yes))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d262180","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/LicenseActivationModal.vue
// module id = 573
// module chunks = 32